import { Dialog, styled } from '@mui/material';

export const StyledDialog = styled(Dialog)`
  & .MuiDialogContent-root {
    margin: 30px 30px 0;
  }

  & .MuiDialogActions-root {
    margin: 0 40px 30px 40px;
    justify-content: space-between;
  }
`;